var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-size"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("redactor.fontSize__label"))+" ")]),_c('v-combobox',{staticClass:"font-size__input",attrs:{"value":_vm.fontSize,"items":_vm.DEFAULT_FONT_SIZES,"solo":"","type":"number"},on:{"change":function($event){return _vm.$emit('changeTextFontSize', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }